import React, { useState, useCallback, useEffect } from 'react';
import 'react-day-picker/lib/style.css';
import { Field } from '@ontruck/orc';
import moment from 'moment';
import styledHourField from './styled';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import Tippy from '@tippyjs/react';

export const t = {
  label: 'Time to trigger',
  past_time: 'Using a time in the past would trigger the task immediatly.',
};

export function changeTimestampHourAndMinutes({ timestamp, hour, minutes }) {
  return moment(timestamp).set('hour', hour).set('minute', minutes).toISOString();
}

const Hour = ({ className, value, setValue }) => {
  const [time, setTime] = useState('');
  const [showWarning, setShowWarning] = useState(false);

  const handleChangeTime = useCallback(
    (e, { value }) => {
      setTime(value);
    },
    [setTime]
  );

  useEffect(() => {
    if (time?.length !== 5) return setShowWarning(false);

    const [hour, minutes] = time.split(':');
    const valueUpdated = changeTimestampHourAndMinutes({ timestamp: value, hour, minutes });
    const valueUpdatedIsBeforeNow = new Date(valueUpdated).getTime() < new Date().getTime();

    setShowWarning(valueUpdatedIsBeforeNow);
    if (valueUpdated !== value) setValue(valueUpdated);
  }, [time, value, setValue]);

  return (
    <div className={className}>
      <Tippy
        visible={showWarning}
        theme="light"
        interactive
        trigger="click"
        maxWidth="200px"
        content={t.past_time}
      >
        <span className="field-container">
          <Field
            dataE2E="schedule-hour"
            value={time || ' '}
            label={t.label}
            name="schedule-hour"
            id={t.label}
            maskedProps={{ mask: '99:99', maskChar: null }}
            onChange={handleChangeTime}
            asideRightText={<ClockIcon />}
          />
        </span>
      </Tippy>
    </div>
  );
};

export default styledHourField(Hour);
